





































































































import { Component, Prop, Vue,Emit,Watch,Mixins} from 'vue-property-decorator'
import { ClassData, EventData,EventExtendedProps, NoticeProps } from "@/scripts/datatypes"
import Common from '@/mixins/common'
import moment from 'moment-timezone'

@Component

export default class ModalEventDetails extends Mixins(Common) {
  @Prop({type: String, default: ''}) private message?: string
  @Prop({type: String, default: 'message.yes'}) private confirmText?: string
  @Prop({type: String, default: 'message.no'}) private cancelText?: string
  @Prop({type: String, default: ''}) private errorMessage?: string

  //@Prop({type: String, default: ''}) private title?: string
  @Prop({type: Object, default: {}}) private theEventData?: EventData

  isActive = true

  title = ''

  dateTime = ''

  exProps = {} as EventExtendedProps

/*
  get span(){
    const start = moment(this.startDateTime || '');
    const end   = moment(this.endDateTime || '');
    if(start.isValid() && end.isValid()){
      return Math.round((end.diff(start,'minutes') / 60) * 10) / 10
    }
    return 0
  }
*/
  get note(){
    if(this.exProps.note){
      return this.exProps.note.replace(/\n/g,'<br>')
    }
    return ''
  }
  
  async created(){
    try{
    if(this.theEventData){
      this.exProps = this.theEventData.extendedProps
      
      this.title = this.theEventData.title || ''
      moment.tz.setDefault(this.theEventData.timeZone);
      // start と end で日付が違うかどうか
      const start = moment(this.theEventData.start)
      const end = moment(this.theEventData.end)
      const isSameday = moment(this.theEventData.start).startOf('day').diff(moment(this.theEventData.end).startOf('day')) === 0 ? true : false

      this.dateTime = start.format('LLLL') + ' – '
      if(isSameday){
        this.dateTime += end.format('LT')
      }else{
        this.dateTime += end.format('LLLL')
      }
    }

    }catch(error){
      console.log(error)
    }
  }

  mounted(){
    //
  }

  selectAction(type: string){
    this.$emit("selectAction",{
      type: type,
      eventId: this.theEventData?.id
    });
  }

  onConfirm(yes: boolean) {
    this.$emit("onConfirm", yes);
  }
}
